"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINOpenChoicesInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("@iconify/react");
var PINInput_1 = require("./PINInput");
var simples_1 = require("../simples");
var utilities_1 = require("../../utilities");
var PINOpenChoicesInput = /** @class */ (function (_super) {
    __extends(PINOpenChoicesInput, _super);
    function PINOpenChoicesInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            value: __spreadArrays((_this.props.value || _this.props.defaultValue || [])),
            fieldValue: ""
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
        _this.getValueOnChange = function (_, complement) { return complement; };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.onKeyPress = function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                _this.onAddChoice();
            }
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.onInputChange = function (event) {
            var value = event.target.value;
            _this.setState({ fieldValue: value });
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.onAddChoice = function (event) {
            if (!_this.state.fieldValue || !_this.state.fieldValue.trim()) {
                return;
            }
            var value = __spreadArrays((_this.state.value || []));
            var newValue = __spreadArrays(value, [_this.state.fieldValue]);
            _this.setState({ fieldValue: "", value: newValue });
            _this.onChange(event, newValue);
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.onDeleteChoice = function (event, choice) {
            var value = __spreadArrays((_this.state.value || []));
            var newValue = value.filter(function (c) { return c !== choice; });
            _this.setState({ value: newValue });
            _this.onChange(event, newValue);
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINOpenChoicesInput' is... Remove this comment to see the full error message
    PINOpenChoicesInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, hiddenRequired = _a.hiddenRequired, error = _a.error, label = _a.label, className = _a.className, type = _a.type, secure = _a.secure, id = _a.id, validation = _a.validation, onChange = _a.onChange, onChangeForm = _a.onChangeForm, onChangeDefault = _a.onChangeDefault, t = _a.t, attr = __rest(_a, ["hiddenRequired", "error", "label", "className", "type", "secure", "id", "validation", "onChange", "onChangeForm", "onChangeDefault", "t"]);
        var finalLabel = ((attr.required && !hiddenRequired) ? "* " : "") + (label || "");
        var inputClassName = "pinopenchoicesinput-input" + ((error || this.state.error) ? " error" : "");
        var addBtnColor = (this.state.fieldValue || "").trim() ? utilities_1.Colors.coal : utilities_1.Colors.silver;
        return (React.createElement("div", { className: "pinopenchoicesinput " + (className || "") },
            React.createElement("div", { className: "pinopenchoicesinput-head" },
                React.createElement("label", { className: "pinopenchoicesinput-label", htmlFor: id || attr.name }, finalLabel)),
            React.createElement("div", { className: "pinopenchoicesinput-container" },
                React.createElement("div", { className: "pinopenchoicesinput-input-container" },
                    React.createElement("input", { className: inputClassName, type: "text", value: this.state.fieldValue, onChange: this.onInputChange, onKeyPress: this.onKeyPress }),
                    React.createElement("div", { className: "pointer", onClick: this.onAddChoice },
                        React.createElement(react_1.Icon, { icon: "mdi:plus-circle", style: { fontSize: "2rem" }, color: addBtnColor }))),
                Boolean(this.state.value)
                    && React.createElement("div", { className: "pinopenchoicesinput-choices-list" }, this.state.value.map(function (choice, index) { return (React.createElement(simples_1.PINPill, { color: "nickel", key: index },
                        React.createElement("span", { className: "mr-xs" }, choice),
                        React.createElement("div", { className: "pointer", onClick: function (event) { return _this.onDeleteChoice(event, choice); } },
                            React.createElement(react_1.Icon, { icon: "mdi:close", style: { fontSize: "1.2rem" }, color: utilities_1.Colors.nickel })))); }))),
            (error || this.state.error)
                && React.createElement("div", { className: "pinopenchoicesinput-error" }, error || this.state.error)));
    };
    PINOpenChoicesInput.className = "PINOpenChoicesInput";
    PINOpenChoicesInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { secure: PropTypes.bool });
    return PINOpenChoicesInput;
}(PINInput_1.PINInput));
exports.PINOpenChoicesInput = PINOpenChoicesInput;
//# sourceMappingURL=PINOpenChoicesInput.js.map